module.exports = __webpack_public_path__ + "img/120.a0a2a597.jpg";